import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LocalstorageService {

  sendMessage: EventEmitter<any> = new EventEmitter();
  constructor() { }

  /**Set LocalStorage Token */
  setToken(key: string, value: any) {
    const str = JSON.stringify(value);
    localStorage.setItem(key, str);
  }

  /**Get LocalStorage Token */
  getToken(key: string): any  {
    const str = localStorage.getItem(key);
    try {
      return JSON.parse(str);
    } catch (error) {
      return null;
    }
  }

  getItem(key:string): any{
    const str = localStorage.getItem(key);
    try {
      return str;
    } catch (error) {
      return null;
    }
  }

  /**Remove LocalStorage Token */
  removeToken(key: string) {
    localStorage.removeItem(key);
  }

}



// WEBPACK FOOTER //
// ./src/app/common/services/localstorage/localstorage.service.ts